import React, { Component } from "react";
// import PreviewAllQuestions from "../Quiz/PreviewAllQuestions";
import { Link } from "react-router-dom";
import EditQuestion from "./EditQuestion";
import AddQuestion from "./AddQuestion";
import PreviewEditQuestion from "./PreviewEditQuestion";
import EmptyEditor from "./EmptyEditor";
import Constant from "../../../Constant";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
const getItemStyle = (isDragging, draggableStyle) => ({
  background: isDragging ? "#09cc89" : "white",
  boxShadow: isDragging ? "0 2px 10px #d7d7d7" : "0 2px 10px #d7d7d7",
});

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  console.log(result);
  return result;
};

export default class QuestionContainer extends Component {
  state = {
    preview: false,
    questionsList: [],
    unitDetails: {
      quiz_unit_id: 378,
      quiz_title: "",
    },
    questionsList: [
      // {
      //   question_id: "1",
      //   question_title:
      //     "Which of the following is NOT one of the basic functions of housekeeping in the hospitality industry?",
      //   game_type_id: "3",
      //   correct_feedback: "<p>0</p>",
      //   incorrect_feedback: "<p>0</p>",
      //   question_options: [
      //     {
      //       option_name: "Making the bed ",
      //       option_id: "15896",
      //       right_answer: "0",
      //       media_id: "0",
      //       media_url: "",
      //     },
      //     {
      //       option_name: "Cleaning the bathroom",
      //       option_id: "15897",
      //       right_answer: "0",
      //       media_id: "0",
      //       media_url: "",
      //     },
      //   ],
      // },
      // {
      //   question_id: "2",
      //   question_title:
      //     "Which of the following is NOT one of the basic functions of housekeeping in the hospitality industry?",
      //   game_type_id: "3",
      //   correct_feedback: "<p>0</p>",
      //   incorrect_feedback: "<p>0</p>",
      //   question_options: [
      //     {
      //       option_name: "Making the bed ",
      //       option_id: "15896",
      //       right_answer: "0",
      //       media_id: "0",
      //       media_url: "",
      //     },
      //     {
      //       option_name: "Cleaning the bathroom",
      //       option_id: "15897",
      //       right_answer: "0",
      //       media_id: "0",
      //       media_url: "",
      //     },
      //   ],
      // },
    ],

    currentQuestion: {
      question_title: "",
      question_options: [],
    },
    gameTypeList: [],
    questionTypeList: [],
    answerTypeList: [],
    questionEditor: false,
  };

  componentDidMount() {
    if (this.props.questionsList) {
      this.setState({
        questionsList: this.props.questionsList,
        topicName: this.props.unitDetails.name,
        description: this.props.unitDetails.description,
        editing: true,
      });
    }
  }

  addNewQuestion = () => {
    this.setState({ isNewQuestion: true });
    this.setState({ preview: true, questionEditor: true });
    var currentQuestion = {
      question_title: "",
      question_options: [],
    };
    this.setState({ currentQuestion: currentQuestion });
  };
  editQuestion = (question) => {
    console.log(question);
    this.setState({ currentQuestion: question });
    this.setState({ preview: true, questionEditor: true });
  };

  showPreview = () => {
    this.setState({ preview: true });
  };
  closePreview = () => {
    this.setState({ preview: false, questionEditor: false });
    this.setState({ currentQuestion: {} });
  };
  onEditQuestion = (question) => {
    console.log(question);
    this.setState({ currentQuestion: question });
  };

  onDragCourse = (result) => {
    console.log(result);
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    const sortCourse = reorder(
      this.state.questionsList,
      result.source.index,
      result.destination.index
    );

    this.setState({
      questionsList: sortCourse,
    });
  };

  addQuestion = () => {
    var sampleQuestion = {
      question_id: "",
      question_title: "",
      game_type_id: "",
      correct_feedback: "",
      incorrect_feedback: "",
      question_options: [
        {
          option_name: " ",
          option_id: "",
          right_answer: "",
          media_id: "",
          media_url: "",
        },
        {
          option_name: "",
          option_id: "",
          right_answer: "",
          media_id: "",
          media_url: "",
        },
      ],
    };

    sampleQuestion.question_id = this.state.questionsList.length + 1;
    sampleQuestion.question_id = sampleQuestion.question_id.toString();
    this.setState({
      currentQuestion: sampleQuestion,
      questionEditor: true,
      preview: true,
    });
  };

  closeEditing = () => {
    this.setState({ questionEditor: false, preview: false });

    var currentQuestion = this.state.currentQuestion;
    var questionsList = this.state.questionsList;
    var sampleQuestion = this.state.sampleQuestion;

    var exist = false;
    for (let i = 0; i < questionsList.length; i++) {
      if (currentQuestion.question_id == questionsList[i].question_id) {
        questionsList[i] = currentQuestion;
        exist = true;
      }
    }
    if (exist == false) {
      questionsList.push(currentQuestion);
    }
    this.setState({ questionsList: questionsList });
  };

  addTopic = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));
    var content = {
      topicType: "4",
      data: this.state.questionsList,
    };

    var urlencoded = new URLSearchParams();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("name", this.state.topicName);
    urlencoded.append("description", this.state.description);
    urlencoded.append("image", this.state.image);
    urlencoded.append("contentType", "quiz");
    urlencoded.append("content", JSON.stringify(content));
    if (this.state.editing === true) {
      urlencoded.append("topicId", this.props.topic_id);
    } else {
      urlencoded.append("courseId", this.props.match.params.course_id);
    }
    urlencoded.append("start", new Date().toISOString());
    // urlencoded.append("end", data.contentType);
    urlencoded.append("isLive", false);
    urlencoded.append("duration", "15");
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    var url;
    if (this.state.editing === true) {
      url = "/topic/update";
    } else {
      url = "/topic/add";
    }

    fetch(Constant.getAPI() + url, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (this.state.editing === true) {
          window.location.href = `#/admin/view-topic/${this.props.course_id}&${this.props.topic_id}`;
        } else {
          window.location.href = `#/admin/course/topics/${this.props.match.params.course_id}`;
        }
      })
      .catch((error) => console.log("error", error));
  };
  onInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  onDuplicateQuestion = (id) => {
    console.log(id);
  };
  onRemoveQuestion = (id) => {
    console.log(id);
  };
  render() {
    return (
      <div className="row m-0 create-quiz">
        <div className="col-4 bar-left bg-white shadow">
          <div class="card-body bg-white">
            <div className="form-group">
              <label htmlFor="topicName">Unit Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Topic Name"
                name="topicName"
                onChange={this.onInputChange}
                value={this.state.topicName}
              />
            </div>
            <div className="form-group">
              <label htmlFor="topicName">Description</label>
              <textarea
                type="text"
                className="form-control"
                placeholder="Enter Topic Name"
                name="description"
                onChange={this.onInputChange}
                value={this.state.description}
              />
            </div>
            <div className="row mt-4 p-2 bg-light font-weight-bold text-success text-uppercase d-flex justify-content-between align-items-center">
              <div className="col-6" onClick={this.closeEditing}>
                All Questions
              </div>

              <div className="col-6">
                {this.state.questionEditor ? (
                  <span>
                    <i className="fa fa-chevron-right text-dark mr-3"></i>
                    Question {this.state.currentQuestion.question_id}
                  </span>
                ) : (
                    ""
                  )}
              </div>
            </div>

            {this.state.questionEditor ? (
              <EditQuestion
                question={this.state.currentQuestion}
                onEditQuestion={this.onEditQuestion}
                isNewQuestion={this.state.isNewQuestion}
                onSave={this.onSave}
              ></EditQuestion>
            ) : (
                <div>
                  <div className="list-group py-3">
                    <DragDropContext onDragEnd={this.onDragCourse}>
                      <Droppable droppableId="droppable1">
                        {(provided, snapshot) => (
                          <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                          // style={getListStyle(snapshot.isDraggingOver)}
                          >
                            {this.state.questionsList.map((element, index) => (
                              <Draggable
                                key={element.question_id}
                                draggableId={element.question_id}
                                index={index}
                              >
                                {(provided, snapshot) => (
                                  <div
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                  >
                                    <div className="pb-3">
                                      <div
                                        style={getItemStyle(
                                          snapshot.isDragging,
                                          provided.draggableProps.style
                                        )}
                                        className="list-group-item d-flex justify-content-between align-items-center"
                                      >
                                        <h4 className="m-0">
                                          Question {element.question_id}
                                        </h4>

                                        <span>
                                          <div class="btn-group">
                                            <button
                                              type="button"
                                              class="btn btn-dark px-2 py-2"
                                              onClick={this.editQuestion.bind(
                                                this,
                                                element
                                              )}
                                            >
                                              EDIT
                                          </button>
                                            <button
                                              type="button"
                                              class="btn btn-dark px-2 py-2 dropdown-toggle dropdown-toggle-split"
                                              id="dropdownMenuSplitButton1"
                                              data-toggle="dropdown"
                                              aria-haspopup="true"
                                              aria-expanded="false"
                                            >
                                              <span class="sr-only">
                                                Toggle Dropdown
                                            </span>
                                            </button>
                                            <div
                                              class="dropdown-menu shadow"
                                              aria-labelledby="dropdownMenuSplitButton1"
                                            >
                                              <h6 class="dropdown-header font-weight-bold border-bottom">
                                                Options
                                            </h6>
                                              <a
                                                class="dropdown-item"
                                                onClick={this.onDuplicateQuestion.bind(
                                                  this,
                                                  element.question_id
                                                )}
                                              >
                                                Duplicate
                                            </a>
                                              <a
                                                class="dropdown-item"
                                                onClick={this.onRemoveQuestion.bind(
                                                  this,
                                                  element.question_id
                                                )}
                                              >
                                                Delete
                                            </a>
                                            </div>
                                          </div>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </Draggable>
                            ))}
                          </div>
                        )}
                      </Droppable>
                    </DragDropContext>

                    {/* <div class="col-lg-12 grid-margin stretch-card">
                  <div class="accordion w-100" id="accordion" role="tablist">
                    {this.state.questionsList.map((question, key) => (
                      <div
                        class="card mb-4"
                        onClick={this.editQuestion.bind(this, question)}
                      >
                        <div class="card-header">
                          <h6 class="mb-0">
                            <a>
                              <div className="row">
                                <div
                                  className="col-10 p-0 question-title"
                                  // dangerouslySetInnerHTML={{
                                  //   __html: question.question_title,
                                  // }}
                                >
                                  {" "}
                                  Question {key + 1}
                                </div>
                                <div className="col-2">
                                  <i
                                    className="fas fa-tv"
                                    onClick={this.showPreview}
                                  ></i>
                                </div>
                              </div>
                            </a>
                          </h6>
                        </div>
                      </div>
                    ))}
                  </div>
                </div> */}
                  </div>
                  <div className="m-0">
                    <div className="col-12 p-0 border-top">
                      <div
                        style={getItemStyle()}
                        className="list-group-item my-3 d-flex justify-content-between"
                      >
                        <h4 className="m-0">Add New Question</h4>
                        <div
                          className="badge badge-success font-weight-bold d-flex justify-content-center align-items-center"
                          onClick={this.addQuestion}
                        >
                          ADD
                      </div>
                      </div>
                    </div>
                  </div>
                  <button
                    type="submit"
                    class="btn btn-primary shadow-sm btn-fw"
                    onClick={this.addTopic}
                  >
                    SAVE QUIZ
                </button>{" "}
                or{" "}
                  <Link to="/admin/courses" className="btn-link">
                    Cancel
                </Link>
                </div>
              )}
          </div>
        </div>

        <div className="col-8 bar-right">
          {this.state.preview ? (
            <div class="row py-3">
              <div class="col-md-12 d-flex align-items-stretch grid-margin new-quiz">
                <PreviewEditQuestion
                  question={this.state.currentQuestion}
                  unitDetails={this.state.unitDetails}
                ></PreviewEditQuestion>
              </div>
            </div>
          ) : (
              <div class="row py-3"></div>
            )}
        </div>
      </div>
    );
  }
}
